<template>
  <nav class="navbar sticky-top navbar-expand-lg">
    <div class="container-fluid">
      <router-link to="/" class="nav-link">
        <img src="../assets/logo.png" class="HeaderLogo" alt="LogoLTB" />
      </router-link>
      <button
      class="navbar-toggler"
      type="button"
      @click="toggleMenu"
      :aria-expanded="menuOpen.toString()"
      aria-label="Toggle navigation"
    >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div :class="['navbar-collapse', menuOpen ? 'show' : 'collapse']" id="navbarSupportedContent">
        <ul class="navbar-nav mb-2 mb-lg-0">
          <li class="nav-item px-2">
            <router-link to="/verpackung" class="nav-link"> Verpackung </router-link>
          </li>
          <li class="nav-item px-2">
            <router-link to="/polstermaterial" class="nav-link">
              Polstermaterial
            </router-link>
          </li>
          <li class="nav-item px-2">
            <router-link to="/folien" class="nav-link"> Folien </router-link>
          </li>
          <li class="nav-item px-2">
            <router-link to="/verpackungszubehoer" class="nav-link">
              Verpackungszubehör
            </router-link>
          </li>
          <li class="nav-item px-2">
            <router-link to="/paletten" class="nav-link">
              Paletten und Holzkisten
            </router-link>
          </li>

          <li class="nav-item px-2 ms-md-5">
            <router-link to="/Kontakt" class="nav-link"> KONTAKT </router-link>
          </li>
        </ul>
      </div>

      <p :class="['anfrage-border', { highlight: showBorder }]">
        <router-link to="/angebot" class="angebotKnopf">
          Sie haben {{ anfragen.length }} Artikel in Ihrer Anfrage
        </router-link>
      </p>
    </div>
  </nav>
</template>

<script>
import { computed } from "vue";
import { anfragenStore } from "@/stores/AnfrageStore";

export default {
  name: "AppHeader",
  setup() {
    const store = anfragenStore();
    const anfragen = computed(() => store.getItems);

    return {
      anfragen,
    };
  },
  methods: {
    toggleMenu() {
      this.menuOpen = !this.menuOpen;
    },
    closeMenu() {
      this.menuOpen = false;
    },
  },
  data() {
  return {
    showBorder: false,
    menuOpen: false,
    borderTimeout: null,
  };
},
watch: {
  'anfragen.length'(newVal, oldVal) {
    if (newVal !== oldVal) {
      this.showBorder = true;
      clearTimeout(this._borderTimeout);
      this._borderTimeout = setTimeout(() => {
        this.showBorder = false;
      }, 1000);
    }
  },
  $route() {
      // Schließe das Menü bei jeder Navigation
      this.closeMenu();
    }
  
},
beforeUnmount () {
  clearTimeout(this._borderTimeout);
},


};
</script>

<!-- <script >
import { computed } from 'vue'
import { anfragenStore } from '@/stores/AnfrageStore'
const store = anfragenStore()
const anfragen = computed(() => store.getItems)


export default {

  name: "AppHeader",

  methods: {
    toggleMenu() {
      this.menuOpen = !this.menuOpen;
    },
  },
  data() {
    return {
      menuOpen: false,
    };
  },
  created() {},
};
</script> -->
